var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        ref: "pay-form",
        staticStyle: { display: "none" },
        attrs: { name: "pay-form", target: "_self", method: "post" },
      },
      [
        _c("input", {
          ref: "page-id",
          attrs: { name: "x_login", type: "hidden" },
        }),
        _c("input", {
          attrs: { name: "x_amount", type: "hidden" },
          domProps: { value: _vm.balanceWithTip },
        }),
        _c("input", {
          ref: "sequence-number",
          attrs: { name: "x_fp_sequence", type: "hidden" },
        }),
        _c("input", {
          ref: "timestamp",
          attrs: { name: "x_fp_timestamp", type: "hidden" },
        }),
        _c("input", {
          ref: "hash",
          attrs: { name: "x_fp_hash", type: "hidden" },
        }),
        _c("input", {
          attrs: { name: "x_first_name", value: "", type: "hidden" },
        }),
        _c("input", {
          attrs: { name: "x_last_name", value: "", type: "hidden" },
        }),
        _c("input", {
          ref: "invoice-number",
          attrs: { name: "x_invoice_num", type: "hidden" },
        }),
        _c("input", {
          ref: "description",
          attrs: { name: "x_description", type: "hidden" },
        }),
        _c("input", {
          attrs: { name: "x_show_form", value: "PAYMENT_FORM", type: "hidden" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }